import { Link } from 'react-router-dom';
import SectionTitle from '@/components/base/SectionTitle';
import { principles, testimonials, siteInfo } from '@/mocks/incidents';

export default function AboutTeaser() {
  return (
    <section className="w-full bg-background-100">
      <div className="mx-auto max-w-content px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-6">
            <SectionTitle
              label="关于我们"
              title="把追踪做得更清楚一点"
              desc={`${siteInfo.name} 是一个以公开信息为基础的资讯整理站点。我们希望读者不只看到零散标题，而是能顺着时间线理解一件事是怎么发生的。`}
            />
            <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2">
              {principles.map((item) => (
                <div key={item.title} className="rounded-lg border border-background-200 bg-background-50 p-4">
                  <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-100 text-accent-800">
                    <i className={`${item.icon} text-lg`}></i>
                  </span>
                  <h3 className="mt-3 font-heading text-sm font-semibold text-foreground-950">{item.title}</h3>
                  <p className="mt-1.5 text-xs leading-relaxed text-foreground-600">{item.desc}</p>
                </div>
              ))}
            </div>
            <Link
              to="/about"
              className="mt-6 inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-600 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-700"
            >
              了解更多
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="lg:col-span-6">
            <h3 className="flex items-center gap-2 font-heading text-sm font-semibold text-foreground-950">
              <i className="ri-chat-quote-line text-primary-600"></i>
              读者怎么说
            </h3>
            <div className="mt-5 space-y-4">
              {testimonials.map((item) => (
                <figure
                  key={item.name}
                  className="rounded-lg border border-background-200 bg-background-50 p-5"
                >
                  <blockquote className="text-sm leading-relaxed text-foreground-700">「{item.text}」</blockquote>
                  <figcaption className="mt-4 flex items-center gap-3">
                    <span className="h-9 w-9 overflow-hidden rounded-full bg-background-200">
                      <img src={item.avatar} alt={`${item.name} 头像`} className="h-full w-full object-cover object-top" />
                    </span>
                    <span className="flex flex-col leading-tight">
                      <span className="text-sm font-medium text-foreground-900">{item.name}</span>
                      <span className="text-[11px] text-foreground-500">{item.role}</span>
                    </span>
                  </figcaption>
                </figure>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}